module.exports = __webpack_public_path__ + "img/ethiopia.3325e9ca.svg";